export function getDisplayedName(nickname: string | null | undefined, alias: string | null | undefined): string {
  return nickname || alias || 'Анонимный пользователь';
}
